/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const Pages = () => {

    const { BaseUrl } = useContext(MyContext);

    const Perams = useParams();
    const Title = Perams.title?.replaceAll('_', ' ');

    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.post(`${BaseUrl}/user_api/u_pagelist.php`)
            .then((res) => {
                console.log("u_pagelist", res);
                setLoading(false);
                setList(res.data.pagelist);
            })
            .catch((error) => {
                console.log("u_pagelist", error);
            });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        console.log(Title);

    }, [Title]);

    useEffect(() => {
        console.log(list);
    }, [list]);

    return (
        <div className='width_container'>
            <div className="bg-white p-[30px] rounded-[30px] mt-[20px]">
                {
                    list?.map((item, index) => {
                        if (item.title.toLowerCase() === Title.toLowerCase()) {
                            return (
                                <div key={index}>
                                    {item.title === "Contact Us" && <h3 className='text-[25px] font-bold mb-[20px]'>{item.title}</h3>}
                                    <p dangerouslySetInnerHTML={{ __html: item?.description }} />
                                </div>
                            );
                        }
                        return null;
                    })
                }
            </div>
        </div>
    )
}

export default Pages
/* jshint ignore:end */